import {
  SkeletonBookingList,
  SkeletonCard,
  SkeletonPagination,
  SkeletonSearchBar,
} from './primitives';

/**
 * Content-only skeleton for the profile page.
 * Use this when the header is already rendered and only the content area is loading.
 */
export function ProfileContentSkeleton() {
  return (
    <div className="space-y-6" aria-busy="true" aria-label="Loading profile content">
      {/* Search - matches DataTable Card structure */}
      <SkeletonCard>
        <SkeletonSearchBar />
      </SkeletonCard>

      {/* Booking rows - matches UnifiedBookingList mobile row structure */}
      <SkeletonBookingList count={5} />

      {/* Pagination */}
      <SkeletonPagination />
    </div>
  );
}
